/**
 * The campaign list page — every ticket sales campaign, filtered by status tab and
 * searched by name. Desktop shows a table inside a card; tablet and phone show
 * cards (two columns, then one), arranged by the stylesheet. The tab and search
 * live in the page address.
 */
import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';
import { DashboardsPage } from '../dashboards/DashboardsPage';
import { SearchInput } from '../dashboards/primitives/SearchInput';

import { NewTicketSalesCampaignButton } from './components/NewTicketSalesCampaignButton';
import { TicketSalesCampaignsListHeader } from './components/TicketSalesCampaignsListHeader';
import { TicketSalesCampaignsListLayout } from './components/TicketSalesCampaignsListLayout';
import { TicketSalesCampaignsResultsBody } from './components/TicketSalesCampaignsResultsBody';
import { TicketSalesCampaignsStatusTabs } from './components/TicketSalesCampaignsStatusTabs';
import { campaignCountLabel } from './ticket-sales-campaigns-list-model';
import { useTicketSalesCampaignsListView } from './use-ticket-sales-campaigns-list-view';

const RESULTS_ID = 'ticket-sales-campaigns-results';

export default function TicketSalesCampaignsListPage() {
  const { hasPermission } = usePermissions();
  const view = useTicketSalesCampaignsListView();

  return (
    <DashboardsPage
      header={<TicketSalesCampaignsListHeader actions={<NewTicketSalesCampaignButton />} />}
    >
      <TicketSalesCampaignsListLayout
        resultsId={RESULTS_ID}
        countLabel={view.loaded ? campaignCountLabel(view.rows.length) : null}
        search={
          <SearchInput
            value={view.search}
            onChange={view.setSearch}
            placeholder="Search campaigns…"
            ariaLabel="Search campaigns"
            style={{ width: '100%' }}
          />
        }
        tabs={
          <TicketSalesCampaignsStatusTabs
            active={view.tab}
            counts={view.counts}
            onChange={view.setTab}
            panelId={RESULTS_ID}
          />
        }
      >
        <TicketSalesCampaignsResultsBody
          rows={view.rows}
          now={view.now}
          loading={view.loading}
          error={view.error}
          onRetry={view.retry}
          tab={view.tab}
          search={view.search}
          canWrite={hasPermission(Permission.WRITE_TICKET_SALES_CAMPAIGNS)}
        />
      </TicketSalesCampaignsListLayout>
    </DashboardsPage>
  );
}
